class GetTheLook {
  constructor(parent) {
    if(!parent) {
      return;
    }

    this.parent = parent;
    this.init();
  }

  init = () =>{
    const elements = document.querySelectorAll('.get-the-look-slider-js');
    elements.forEach((item)=>{
      this.swiper(item)
    })
  }

  swiper = (element) => {
    let loop = element.getAttribute("data-loop") == "true" ? true : false;
    let navigation = element.getAttribute("data-navigation") == "true" ? true : false;
    let slidesPerView = parseFloat(element.getAttribute('data-columns'));
    let elId = element.getAttribute("data-id");
    let spaceBetween = 24;

    if (window.innerWidth > 750 && window.innerWidth < 990) {
      slidesPerView = 3;
      spaceBetween = 12;
    }

    if (window.innerWidth < 750) {
      slidesPerView = parseFloat(element.getAttribute('data-m-columns'));
      spaceBetween = 12;
    }

    if (navigation) {
      navigation = {
        nextEl: `.${elId} .swiper-button-next`,
        prevEl: `.${elId} .swiper-button-prev`,
      };
    }

    let swiper = new Swiper(element, {
      // Optional parameters
      loop,
      navigation,
      slidesPerView,
      spaceBetween
    });
  };
}
new GetTheLook(document.querySelector('.section-get-the-look'));